// Global
import React from 'react';
import clsx from 'clsx';
import styles from './HeroDecor.module.scss';
import { useIsMobile } from 'lib/hooks/useIsMobile';

export const HeroDecor = () => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.decorWrapper}>
      <svg
        className={clsx(styles.decorStylePillsbury, styles.decorColor)}
        xmlns="http://www.w3.org/2000/svg"
        width={isMobile ? '375' : '1260'}
        height={isMobile ? '26' : '56'}
        viewBox={isMobile ? '0 0 375 26' : '0 0 1260 56'}
        fill="none"
      >
        {isMobile ? (
          <path
            d="M0 26H375V20.3091C375 20.3091 343.49 9.90577 302.214 7.25C260.938 4.59424 242.057 16.9423 176.273 16.9423C110.488 16.9423 82.4219 -16.3025 0 12.4254V26Z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M0 57.6667H1260V44.1667C1260 44.1667 1154.12 6.81675 1015.44 0.51675C876.75 -5.78325 813.312 54.1801 592.276 54.1801C371.24 54.1801 276.938 -24.6833 0 43.4652V57.6667Z"
            fill="currentColor"
          />
        )}
      </svg>
    </div>
  );
};
